import { isNotNullable } from "@/utils/guards";

import { handleApiResponse } from "./handleApiResponse";

export const handleApiResponseAssertData = async <
    P extends unknown[],
    R extends {
        error: unknown;
        data: unknown;
        response: Response;
        request?: Request;
    },
>(
    func: (...args: P) => Promise<R>,
    errorMessage: string = "No response received",
    noDataMessage: string = "No response data",
    ...args: P
): Promise<
    Omit<Omit<R, "error" | "request">, "data"> & {
        data: NonNullable<R["data"]>;
    }
> => {
    const result = await handleApiResponse(func, errorMessage, ...args);

    const { data, ...rest } = result;

    if (!isNotNullable(data)) {
        throw new Error(noDataMessage);
    }

    return {
        ...rest,
        data: data,
    };
};
